import '../TableDesign.css'
import '../App.css'
import React, {useState} from 'react';
import { NavComponent } from '../navigationComponents/NavComponent';
import {
    HiArrowRightOnRectangle,
    HiH1,
  } from "react-icons/hi2";
  import { FaCocktail } from 'react-icons/fa'; // Import the cocktail icon

import ShibaLogo from '../pictures/shibaLogo.jpeg';
import CocktailTokenLogo from '../pictures/cryptobartl_logo.png';
import oldtimerLogo from '../pictures/OldTimerAILogo.jpeg';
import CryGIAComingSoon from '../pictures/CryGIAComingSoon.png';
import virtualBarLogo from '../pictures/BarPic_front.png';
import EasterNFTGameLogo from '../pictures/EasterNFTLogo.png';


import styled from 'styled-components';

const StyledDiv = styled.div`
margin: auto;
padding: 15px;
background-color: #2c2c2c;
opacity: 0.95;
text-align: center;
width: 70%;
border-radius: 20px;
outline: none;
border: transparent;
color: white;
font-family: Verdana, Geneva, Tahoma, sans-serif;
box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;

const StyledDivProject = styled.div`
  margin: auto;
  padding: 15px;
  background-color: #1a1a2e;
  opacity: 0.95;
  text-align: center;
  width: 55%;
  border-radius: 20px;
  outline: none;
  border: transparent;
  color: white;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

  h1 {
    font-size: 2rem; /* Default size */
    word-wrap: break-word; /* Ensure text wraps within the box */
  }

  @media (max-width: 768px) {
    width: 90%; /* Adjust width for smaller screens */

    h1 {
      font-size: 1.5rem; /* Smaller font size for mobile */
    }
  }
`;

const StyledDivImg = styled.div`
margin: auto;
padding: 15px;
background-color: #ffffff;
width: fit-content;
border-radius: 20px;
outline: none;
border: transparent;
color: white;
font-family: Verdana, Geneva, Tahoma, sans-serif;
box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;

const StyledDivImgCCK = styled.div`
margin: auto;
padding: 15px;
background-color: black;
width: fit-content;
border-radius: 20px;
outline: none;
border: transparent;
color: white;
font-family: Verdana, Geneva, Tahoma, sans-serif;
box-shadow: 0 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;

const StyledDivImgOldtimer = styled.div`
margin: auto;
padding: 15px;
width: fit-content;
border-radius: 20px;
outline: none;
border: transparent;
color: white;
font-family: Verdana, Geneva, Tahoma, sans-serif;
box-shadow: 0 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
background: #eddcd3;
background: radial-gradient(circle, rgba(237, 220, 211, 1) 0%, rgba(228, 247, 247, 1) 100%);
`;


const StyledDivImgNeon = styled.div`
margin: auto;
padding: 15px;
max-width: 100%;
width: 90%;
border-radius: 20px;
outline: none;
border: transparent;
color: white;
font-family: Verdana, Geneva, Tahoma, sans-serif;
box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
background: #00ffff;
`;

const StyledDivImgPurple = styled.div`
margin: auto;
padding: 15px;
width: fit-content;
border-radius: 20px;
outline: none;
border: transparent;
color: white;
font-family: Verdana, Geneva, Tahoma, sans-serif;
box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
background: #b86fec;
`;


const StyledHeader = styled.h1`
  font-size: 52px;
  text-align:b86fec center;
  color: #;
  text-shadow: 4px 4px 10px rgba(0, 0, 0, 0.7); /* Stronger shadow */
  font-family: 'Arial', sans-serif; /* Use a clean, professional font */
  margin-bottom: 20px;
`;

const StyledButton = styled.button`

justify-content: center;
padding: 10px 20px;

  background-color: #black;
  color: white;
  border: 2px solid #9a5ecb; /* Added border color */
  border-radius: 15px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    background-color: #9a5ecb;
    transform: scale(1.05); /* Slight zoom effect */
  }

  svg {
    margin-left: 8px; /* Space between text and icon */
    font-size: 20px;
  }
`;

//useEffect hook tells our app to do something after rendering
function Homepage()
{
  
  //for collapsing
  const [openUsefulLinks, setOPenUsefulLinks] = useState(false);

  const toggle_UsefulLinks = () => {
    setOPenUsefulLinks(!openUsefulLinks);
  };


  //in return is where we are rendering our data
  return (

    <main>
      <div id="divHomepage" className='homepageDesign'>       

      <NavComponent/>


      <h1 style = {{fontSize: '52px', textAlign:'center'}}> Welcome to CryptoBARtl ! </h1>
      <br/>
      <p>Welcome to the official CryptoBartl homepage!</p>
      <p>By following us and exploring this platform, you will gain valuable insights into the world of cryptocurrency.</p>
      <p>We provide innovative services designed to transform your personal and business ventures.</p>
      <br/>
      <br/>
      
      {/* What We Offer Section */}
      {!window.matchMedia("(max-width: 768px)").matches ? (
        <section
          style={{
            textAlign: "center",
            padding: "20px",
            margin: "40px auto",
            maxWidth: "90%",
          }}
        >
        
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            gap: "20px",
          }}
        >
          {/* Left Box */}
          <div
            style={{
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)", // 3D-like shadow
              //backgroundColor: "#f9f9f9",
              width: "30%",
              textAlign: "center",
              zIndex: 2, // Higher stacking context to appear above the arrow
              transition: "transform 0.3s ease, box-shadow 0.3s ease", // Smooth hover effect
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow = "0 12px 24px rgba(0, 0, 0, 0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.2)";
              }}
          >
            <h3 style={{ color: "#b86fec", fontSize: "1.5rem", marginBottom: "10px", textAlign: "center" }}>
              E.g.: Reward Token
            </h3>
            <p style={{ fontSize: "1rem", color: "#333", lineHeight: "1.6" }}>
              Launch your own reward token to incentivize user engagement and loyalty.
            </p>
            <ul
              style={{
                listStyleType: "disc",
                paddingLeft: "20px",
                fontSize: "1rem",
                color: "#333",
                lineHeight: "1.8",
                marginBottom: "15px",
              }}
            >
              <li>Logo as NFT</li>
              <li>Company's name as token</li>
            </ul>
            <p>Motivate employees or reward loyal customers with your own digital token.</p>
          </div>
      
          {/* Middle Box */}
          <div
            style={{
              padding: "20px",
              borderRadius: "10px",
              border: "2px solid #b86fec", // Purple border

              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)", // 3D-like shadow
              //backgroundColor: "#f9f9f9",
              width: "30%",
              textAlign: "center",
              position: "relative", // For arrows
              transition: "transform 0.3s ease, box-shadow 0.3s ease", // Smooth hover effect
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow = "0 12px 24px rgba(0, 0, 0, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.2)";
            }}
          >
            <h3 style={{  fontSize: "1.7rem", marginBottom: "10px", textAlign: "center" }}>
            Token Creation Services by CryptoBartl
            </h3>
            <br/>
            <p style={{ fontSize: "1rem", color: "#333", lineHeight: "1.6" }}>
              Explore our wide range of services tailored to your Web3 needs.
            </p>
            <br/>
            <div
              style={{
                textAlign: "center", // Aligns the text in the center
                fontSize: "1rem",
                color: "#333",
                lineHeight: "1.8",
              }}
            >
              <p><strong>ERC20 Token Creation Packages</strong> <br/>(Basic, Advanced, Custom)</p>
              <p><strong>Branded NFT Services</strong></p>
              <p>Enhance your knowledge on crypto</p>
            </div>
      
            {/* Left Arrow */}
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "-40px",
                transform: "translateY(-50%)",
                width: "40px",
                height: "2px",
                backgroundColor: "#b86fec",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
              }}
            ></div>
      
            {/* Right Arrow */}
            <div
              style={{
                position: "absolute",
                top: "50%",
                right: "-40px",
                transform: "translateY(-50%)",
                width: "40px",
                height: "2px",
                backgroundColor: "#b86fec",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
              }}
            ></div>
          </div>
      
          {/* Right Box */}
          <div
            style={{
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)", // 3D-like shadow
              //backgroundColor: "#1a1a2e",
              width: "30%",
              textAlign: "center",
              transition: "transform 0.3s ease, box-shadow 0.3s ease", // Smooth hover effect
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow = "0 12px 24px rgba(0, 0, 0, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.2)";
            }}
          >
            <h3 style={{ color: "#b86fec", fontSize: "1.5rem", marginBottom: "10px", textAlign: "center" }}>
              Launched Projects
            </h3>
            <p style={{ fontSize: "1rem", color: "#333", lineHeight: "1.6" }}>
              Discover successful projects we've launched already:
            </p>
            <a 
              href="#ShibConisDIV" 
              style={{ textDecoration: "none", color: "#b86fec", cursor: "pointer" }}
            >
                <span style={{ color: "#b86fec" }}>➔</span> {/* Arrow pointing to the name */}
                ShibConis
            </a> <br/>
            <a 
              href="#OldtimerNFTs" 
              style={{ textDecoration: "none", color: "#b86fec", cursor: "pointer" }}
            >
              <span style={{ color: "#b86fec" }}>➔</span> {/* Arrow pointing to the name */}
              Oldtimer NFTs
            </a> <br/>
            <a 
              href="#CryptoCocktailParty" 
              style={{ textDecoration: "none", color: "#b86fec", cursor: "pointer" }}
            >
              <span style={{ color: "#b86fec" }}>➔</span> {/* Arrow pointing to the name */}
              Virtual NFT Cocktail Bar
            </a>
            <p>...</p>
          </div>
        </div>
      </section>
      ) : (
        <div
          style={{
            padding: "20px",
            borderRadius: "10px",
            border: "2px solid #b86fec", // Purple border
            boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)", // 3D-like shadow
            width: "90%",
            textAlign: "center",
            margin: "20px auto",
          }}
        >
          <h3 style={{ fontSize: "1.7rem", marginBottom: "10px", textAlign: "center" }}>
            Token Creation Services by CryptoBartl
          </h3>
          <p style={{ fontSize: "1rem", color: "#333", lineHeight: "1.6" }}>
            Explore our wide range of services tailored to your Web3 needs.
          </p>
          <br/>
            <div
              style={{
                textAlign: "center", // Aligns the text in the center
                fontSize: "1rem",
                color: "#333",
                lineHeight: "1.8",
              }}
            >
              <p><strong>- ERC20 Token Creation Packages</strong> <br/>(Reward, Basic, Advanced, Custom)</p>
              <p><strong>- Branded NFT Services</strong></p>
              <p>- Enhance your knowledge on crypto</p>
            </div>
        </div>
      )}
      
      <br/>

      <a href="/Shop" style={{ textDecoration: 'none' }}>
          <StyledButton>
          Create your Token
            <HiArrowRightOnRectangle />
          </StyledButton>
        </a> 

      <br/>
      <br/>
      <br/>
      <br/>
      <div style={{
        textAlign: 'center',
        margin: 'auto',
        padding: '15px',
        border: '1px solid #ccc', // Light gray border
        borderRadius: '10px', // Rounded corners
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Subtle shadow
        backgroundColor: 'transparent', // Transparent background
        width: '70%'

      }}>
        <h1> Primary Use Cases for Our Customers' Tokens: </h1>
        <p></p>
        <ul style={{ listStyleType: 'disc', textAlign: 'left', margin: '0 auto', maxWidth: '70%', lineHeight: '1.8' }}>
          <li><strong>Brand Identity and Community Building:</strong> A custom token helps build a strong, identifiable community around a product or cause.</li>
          <li><strong>Reward and Loyalty Programs:</strong> Tokens can be used to reward users for specific behaviors (e.g., staking, referring others, providing liquidity).</li>
          <li><strong>Access to Exclusive Features or Services:</strong> Tokens provide access to unique features, creating a sense of ownership and loyalty among early adopters and supporters.</li>
          <li><strong>Community Engagement:</strong> Tokens help bootstrap user growth and foster community engagement.</li>
        </ul>

        <br />
        
      </div>
      <br/>
      <br/>
      <p>If you are interested in learning more about crypto tokens, you should visit our 
        <a  href="/TokenFactory"> #Token Factory</a> </p>
      <p>If you are interested in NFTs, take a ride to our 
       <a  href="/NFTFactory"> #NFT Factory</a> </p>
      <p>Either way, do not forget to visit and get inspired by our already launched projects, like the 
      <a 
        href="https://crypto-cocktailparty.com/Homepage" 
        target="_blank" 
        rel="noopener noreferrer"
      >
          <FaCocktail size={20} style={{ marginLeft: '8px',marginRight: '2px', color: '#b86fec' }} /> {/* Cocktail icon */}
          Virtual Crypto Cocktail Bar
          <FaCocktail size={20} style={{ marginLeft: '4px',  color: '#b86fec' }} /> {/* Cocktail icon */}
          
      </a>
        .</p>
      <br/>
      <br/>
      <br/>
      <br/>

      <StyledDiv id="HomepageCryptoWorld">
        <StyledHeader> Crypto World </StyledHeader>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
        <p>Whether you're new to the world of cryptocurrency or looking to refresh your knowledge, explore our Crypto World section.</p>
        <p>It provides essential information about cryptocurrency, including topics such as:</p>
        <p>What is a blockchain?</p>
        <p>Why a Memecoin?</p>
        <p>Token vs. Memecoin vs. NFT?</p>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
       
        <br />
        <a href="/CryptoWorld" style={{ textDecoration: 'none' }}>
          <StyledButton>
            Go to the CryptoWorld
            <HiArrowRightOnRectangle />
          </StyledButton>
        </a>      
      </StyledDiv>

      <br/>
      <br/>

      <StyledDiv id="HomepageCryptoWorld">
        <StyledHeader> Token Factory </StyledHeader>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
        <p>Do you dream of having your own Crypto Token?</p>
        <p>First it is essential to explore the various options we provide for token.</p>
        <br/>
        <p>This service will be provided to you soon.</p>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
       
        <br />
        <a href="/TokenFactory" style={{ textDecoration: 'none' }}>
          <StyledButton>
          Go to the Token Factory
            <HiArrowRightOnRectangle />
          </StyledButton>
        </a>  
      </StyledDiv>
      
      <br/>
      <br/>

      <StyledDiv id="HomepageCryptoWorld">
        <StyledHeader> NFT Factory </StyledHeader>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
        <p>Get your own personal NFT on the blockchain!</p>
        <p>First you have to understand all the options we offer in the creation of the smartcontract.</p>
        <p>Special discounts on displying your NFT on our upcoming marketplace will be granted.</p>
        <br/>
        <p>This service will be available to you shortly.</p>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
       
        <br />
        <a href="/NFTFactory" style={{ textDecoration: 'none' }}>
          <StyledButton>
          Go to the NFT Factory
            <HiArrowRightOnRectangle />
          </StyledButton>
        </a>  
      </StyledDiv>
      
      <br/>
      <br/>
      
      <StyledDivProject id="ShibConisDIV">
        <StyledHeader> PROJECT 0: ShibConis Memecoin </StyledHeader>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
        <br/>
        <br/>
        <StyledDivImg>
        <img src={ShibaLogo} alt="ShibConis image" height = {200} width = {200} />
        </StyledDivImg>
        <br/>
        <br/>
        <a href="https://basescan.org/address/0x038E4Cb215731B927Af31c320360DC37bd14b2d7">Check it on the Base blockchain!</a>
        <p>ShibConis (SHB) – A real utility token inspired by our Shiba Inu family (Chancey&Milo), built for community, charity, and crypto fun.</p>
        <br/>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
       
        <br/>
        <a href="/TokenFactory/#ShibConis"> 
        <StyledButton>
            Go to ShibConis Token  - details
            <HiArrowRightOnRectangle />
          </StyledButton>
        </a>
      </StyledDivProject>
      
      <br/>
      <br/>
      
      <StyledDivProject id="CCKDIV">
        <StyledHeader> PROJECT 1: CCK </StyledHeader>
        <StyledHeader> The Cocktail Token </StyledHeader>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
        <br/>
        <br/>
        <StyledDivImgCCK>
        <img src={CocktailTokenLogo} alt="Cocktail token image" height = {200} width = {200} />
        </StyledDivImgCCK>
        <br/>
        <br/>
        <p>Buy a CCK token and become part of the CKK Family!</p>
        <br/>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
        <br/>
        <a href="/TokenFactory/#CocktailToken"> 
        <StyledButton>
            Go to Cocktail Token  - details
            <HiArrowRightOnRectangle />
          </StyledButton>
        </a>
      </StyledDivProject>

      <br/>
      <br/>

      <StyledDivProject id="CryptoCocktailParty">
        <StyledHeader> PROJECT 2: Virtual Crypto Cocktail Bar </StyledHeader>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
        <br/>
        <br/>
        <StyledDivImgNeon>
        <img src={virtualBarLogo} alt="virtualBarLogo" height = {200} width = {'auto'} />
        </StyledDivImgNeon>
        <br/>
        <br/>
        <h2 style={{ textAlign: 'center' }}>Visit the virtual Crypto Cocktail Bar!</h2>
        <FaCocktail size={20} style={{ marginLeft: '8px',marginRight: '2px', color: '#b86fec' }} /> {/* Cocktail icon */}
        <p> Connect your wallet and explore the world of cocktails in the metaverse.</p>
        <p>  Trade exclusive NFTs, connect your wallet and experience the ultimate virtual bar. </p>
        <p>  Don't forget to visit the Crypto Bar and unlock the stories behind each cocktail!</p>
        <br/>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
        <br/>
        <a href="https://crypto-cocktailparty.com/Homepage"> 
        <StyledButton>
            Visit the Crypto Cocktail Bar
            <HiArrowRightOnRectangle />
          </StyledButton>
        </a>
      </StyledDivProject>

      <br/>
      <br/>

      <StyledDivProject id="OldtimerNFTs">
        <StyledHeader> PROJECT 3: Oldtimer NFTs </StyledHeader>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
        <br/>
        <br/>
        <StyledDivImgOldtimer>
        <img src={oldtimerLogo} alt="oldtimerLogo" height = {200} width = {200} />
        </StyledDivImgOldtimer>
        <br/>
        <br/>
        <p>Give your oldtimer the high-tech flair and turn it into digital art - on the blockchain!</p>
        <p>A picture of the vehicle, the important data about your car and.. ta daaa! You get your NFT!</p>

        <p><a href="https://opensea.io/collection/oldtimernftcollection">Visit our OpenSea collection</a>
        </p> 
        <br/>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
       <br/>
        <a href="/ProjectOldtimerNFT"> 
        <StyledButton>
            Visit the Oldtimer NFT Project
            <HiArrowRightOnRectangle />
          </StyledButton>
        </a>
      </StyledDivProject>

      <br/>
      <br/>

      <StyledDivProject id="EasterGame">
        <StyledHeader> PROJECT 4: NFT Easter Game </StyledHeader>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
        <br/>
        <br/>
        <StyledDivImgPurple>
        <img src={EasterNFTGameLogo} alt="EasterNFTGameLogo" height = {200} width = {200} />
        </StyledDivImgPurple>
        <br/>
        <br/>
        <p> Buy a ticket (NFT) to crack the Easter Egg and discover the hidden treasure <br/> by claiming your reward!
          </p> 
        <br/>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
        <br/>
        <a href="https://crypto-cocktailparty.com/EasterEvent"
          target="_blank" 
          rel="noopener noreferrer"> 
        <StyledButton>
            Go to the NFT Easter Game
            <HiArrowRightOnRectangle />
          </StyledButton>
        </a>
      </StyledDivProject>

      <br/>
      <br/>
      
      <StyledDivProject id="CryGiaMarketplace">
        <StyledHeader> PROJECT 5: CryGIA </StyledHeader>
        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
        <br/>
        <br/>
        <h1>The Ultimate NFT Marketplace </h1>

        <StyledDivImg>
        <img src={CryGIAComingSoon} alt="CryGIAComingSoon" height = {200} width = {200} />
        </StyledDivImg>
        
        <h2 style={{ textAlign: 'center' }}>Will be launched in 2026.</h2>
        <br/>
        <br/>
      </StyledDivProject>

      <br/>
      <br/>
      <br/>
      <br/>

      
        <div id="EndPage">
        <button onClick={toggle_UsefulLinks}>
                {'USEFUL LINKS'} 
                </button>
                {openUsefulLinks && (
                  <div className="toggle">
                    <br/>
                    <br/>
                    <a href="https://cryptobartl.com/TokenRequest">Token Request Submit Form</a>
                    <br/>
                    <a href="https://cryptobartl.com/TokenOrderProcess">Token Order Process</a>
                    <br/>
                    <a href="https://cryptobartl.com/Legals">Legals</a>
                    <p> </p>
                  </div>
                )}
                <br/>
                <br/>


        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
        <p style={{textAlign: "center"}}>Copyright © 2025 CryptoBartl</p>
        </div>
      

    </div>
  </main>




  ) 
  
}

export default Homepage;
